module.exports = __webpack_public_path__ + "media/factions.c82b1ad1.mp4";